import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import VillagerShopData from "../Components/VillagerShopData";

function VillagerMarkets() {
  return (
    <Box sx={{ flexGrow: 1, py: 4 }}>
      <VillagerShopData />
    </Box>
  );
}

export default VillagerMarkets;
